/* Top-right, under the app bar: the bottom-right corner belongs to progress panels. */
.viewport {
  position: fixed;
  inset-block-start: 3.5rem;
  inset-inline-end: 0;
  z-index: var(--wv-z-toast);
  display: grid;
  gap: var(--wv-space-2);
  inline-size: min(24rem, 100vw);
  margin: 0;
  padding: var(--wv-space-6);
  list-style: none;
  outline: none;
}

.toast {
  position: relative;
  display: grid;
  gap: var(--wv-space-1);
  padding: var(--wv-space-4) var(--wv-space-10) var(--wv-space-4) var(--wv-space-4);
  border: 1px solid var(--wv-border);
  border-inline-start: 2px solid var(--wv-text-muted);
  border-radius: var(--wv-radius-2);
  background: var(--wv-surface);
  box-shadow: var(--wv-shadow-3);
  animation: toast-in var(--wv-duration-base) var(--wv-ease);
}

.toast[data-state="closed"] {
  animation: toast-out var(--wv-duration-fast) var(--wv-ease) forwards;
}

.toast[data-swipe="move"] {
  transform: translateX(var(--radix-toast-swipe-move-x));
}

.success {
  border-inline-start-color: var(--wv-success);
}

.danger {
  border-inline-start-color: var(--wv-danger);
}

.title {
  font-size: var(--wv-text-sm);
  font-weight: var(--wv-weight-semibold);
}

.description {
  color: var(--wv-text-muted);
  font-size: var(--wv-text-sm);
}

.close {
  position: absolute;
  inset-block-start: var(--wv-space-3);
  inset-inline-end: var(--wv-space-3);
  display: grid;
  place-items: center;
  inline-size: 1.5rem;
  block-size: 1.5rem;
  padding: 0;
  border: 0;
  border-radius: var(--wv-radius-1);
  background: none;
  color: var(--wv-text-muted);
  cursor: pointer;
}

.close:hover {
  color: var(--wv-text);
}

.close:focus-visible {
  outline: 2px solid var(--wv-focus);
}

@keyframes toast-in {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
}

@keyframes toast-out {
  to {
    opacity: 0;
    transform: translateX(16px);
  }
}
